import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 根据粉丝id，获取聊天记录
export function login(username,password,callback){
	request({
			method: 'post',
			url: 'login/login',
			data: {
			  username: username,
		      password: password,
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}